import { render, staticRenderFns } from "./WalletNotConnect.vue?vue&type=template&id=d100fcd4&scoped=true&"
import script from "./WalletNotConnect.vue?vue&type=script&lang=js&"
export * from "./WalletNotConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d100fcd4",
  null
  
)

export default component.exports